/* eslint-disable @typescript-eslint/no-explicit-any */
export const getErrorMessage = (
  error: any,
): { message: string; status?: number } => {
  const status = error?.response?.status || error?.status;
  const statusText = error?.response?.statusText || error?.statusText;
  const apiMessage = error?.response?.data?.message || error?.data?.message;
  const errorMessage = error?.message;

  const isNetworkError =
    !status &&
    (errorMessage?.toLowerCase().includes("network") ||
      errorMessage?.toLowerCase().includes("fetch") ||
      errorMessage?.toLowerCase().includes("failed to fetch") ||
      errorMessage?.toLowerCase().includes("connection") ||
      errorMessage?.toLowerCase().includes("internet_disconnected") ||
      errorMessage?.toLowerCase().includes("err_internet_disconnected") ||
      error?.code === "NETWORK_ERROR" ||
      error?.name === "NetworkError");

  const isApiServiceError =
    error?.name === "TypeError" &&
    errorMessage?.includes("Cannot read properties of undefined");

  const statusMessages: { [key: number]: string } = {
    400: "The request was invalid. Please check your information and try again.",
    401: "Your session has expired. Please log in again.",
    403: "You don't have permission to perform this action.",
    404: "Resource not found, please contact support.",
    409: "This action conflicts with existing data. Please refresh and try again.",
    422: "Some information is invalid. Please review and correct.",
    429: "Too many requests. Please wait a moment and try again.",
    500: "A server error occurred. Please try again in a few moments.",
    502: "The service is temporarily unavailable. Please try again later.",
    503: "The service is currently under maintenance. Please try again later.",
  };

  let userMessage = "Something went wrong. Please try again.";

  if (isApiServiceError) {
    userMessage =
      "Network connection lost. Please check your internet and try again.";
  } else if (isNetworkError) {
    userMessage = "Unable to connect. Please check your internet connection.";
  } else if (status && statusMessages[status]) {
    userMessage = statusMessages[status];
  } else if (apiMessage && !apiMessage.toLowerCase().includes("resource")) {
    userMessage = apiMessage;
  } else if (errorMessage && !errorMessage.toLowerCase().includes("resource")) {
    userMessage = errorMessage;
  } else if (statusText) {
    userMessage = statusText;
  }

  return { message: userMessage, status };
};

export const handleApiError = (
  error: any,
  context: string = "",
  showToast: boolean = true,
  toastFunction?: (
    message: string,
    type: "error" | "success" | "warning",
  ) => void,
) => {
  const { message, status } = getErrorMessage(error);

  const shouldAddContext =
    !message.toLowerCase().includes("network") &&
    !message.toLowerCase().includes("connection") &&
    !message.toLowerCase().includes("internet") &&
    !message.toLowerCase().includes("unable to complete") &&
    context !== "";

  const fullMessage = shouldAddContext ? `${context}: ${message}` : message;

  if (showToast && toastFunction) {
    toastFunction(fullMessage, "error");
  }

  return { message: fullMessage, status, originalError: error };
};
